define('infoArchitecture/coreRoutes',[
    'lib/knockout',
    'lib/lodash4',
    'services/agentDashboardAuth',
    'services/authService',
    'services/componentViewService',
    'services/embeddingService',
    'services/featureToggleService',
    'services/navHelper',
    'services/routeService',
    'viewModels/appView',
    'infoArchitecture/siteMap'
], function (
    ko,
    _,
    agentDashboardAuth,
    authService,
    componentViewService,
    embeddingService,
    featureToggleService,
    navHelper,
    routeService,
    appView,
    siteMap
) {
    'use strict';

    var coreRoutes = {

        '#noop': {
            handler: function () {
                appView.subViews.setActiveView('noop');
            }
        },

        '#phones': {
            handler: function () {
                embeddingService.showPhoneSelection();
            },
            fixedHeight: true
        },

        '#activateQueues': {
            handler: function() {
                navHelper.navigateTo('#/analytics/queues/activate/me');
            },
            fixedHeight: true
        },

        '#interactions': {
            handler: function() {
                embeddingService.notifyInteracting();
            }
        },

        '#myAccount': {
            pageInfo: siteMap.myAccount,
            handler: function () {
                appView
                    .subViews.setActiveView('appMain')
                    .subViews.setActiveView('myAccount');
            }
        },

        '#admin/scheduledCallbacks': {
            handler: function () {
                navHelper.navigateTo('#/analytics/outbound/scheduledCallbacks');
            },
            fixedHeight: true
        },

        '#dashboard': {
            pageInfo: siteMap.dashboard,
            handler: function () {
                featureToggleService.getFeatureToggle('WEM-1242_Evaluation-Dashboard-Deprecation')
                .then(function (enabled) {
                    if (enabled) {
                        navHelper.navigateTo('#/analytics/agents/evaluations');
                    } else {
                        appView
                            .subViews.setActiveView('appMain')
                            .subViews.setActiveView("privilegedView")
                            .subViews.setActiveView('dashboard')
                            .showDefaultDashboard();
                    }
                });
            },
            fixedHeight: false
        },

        '#dashboard/contactCenter': {
            pageInfo: siteMap.dashboard,
            handler: function () {
                navHelper.navigateTo('#/analytics/dashboards');
            }
        },

        '#dashboard/qualityAdmin': {
            pageInfo: siteMap.dashboard,
            handler: function () {
                featureToggleService.getFeatureToggle('WEM-1242_Evaluation-Dashboard-Deprecation')
                .then(function (enabled) {
                    if (enabled) {
                        navHelper.navigateTo('#/analytics/agents/evaluations');
                    } else {
                        appView
                        .subViews.setActiveView('appMain')
                        .subViews.setActiveView("privilegedView")
                        .subViews.setActiveView('dashboard')
                        .dashboardViews.setActiveView("qualityAdmin");
                    }
                });
            }
        },

        '#dashboard/qualityEvaluator': {
            pageInfo: siteMap.dashboard,
            handler: function () {
                featureToggleService.getFeatureToggle('WEM-1242_Evaluation-Dashboard-Deprecation')
                .then(function (enabled) {
                    if (enabled) {
                        navHelper.navigateTo('#/analytics/agents/evaluations');
                    } else {
                        appView
                            .subViews.setActiveView('appMain')
                            .subViews.setActiveView("privilegedView")
                            .subViews.setActiveView('dashboard')
                            .dashboardViews.setActiveView("qualityEvaluator");
                    }
                });
            }
        },

        '#dashboard/agent': {
            handler: function () {
                if(agentDashboardAuth.canViewWfmSchedule() && !agentDashboardAuth.canViewAgentData()) {
                    navHelper.navigateTo('#/analytics/agents/schedule/me');
                } else {
                    navHelper.navigateTo('#/analytics/agents/performance/me');
                }
            }
        },

        '#dashboard/agent/performance': {
            pageInfo: siteMap.agentDashboard,
            handler: function () {
                navHelper.navigateTo('#/analytics/agents/performance/me');
            }
        },

        '#dashboard/agent/time': {
            pageInfo: siteMap.agentDashboard,
            handler: function () {
                navHelper.navigateTo('#/analytics/agents/status/me');
            }
        },

        '#dashboard/agent/evaluations': {
            pageInfo: siteMap.agentDashboard,
            handler: function () {
                navHelper.navigateTo('#/analytics/agents/evaluations/me');
            }
        },

        // Component dashboard views
        '#dashboard/agent/schedule': {
            pageInfo: siteMap.agentDashboard,
            handler: function () {
                navHelper.navigateTo('#/analytics/agents/schedule/me');
            }
        },

        '#dashboard/agent/schedule/timeOffRequest/:idTor': {
            pageInfo: siteMap.agentDashboard,
            handler: function () {
                navHelper.navigateTo('#/analytics/agents/schedule/me');
            }
        }
    };

    return coreRoutes;
});

